import { loginByUsername, logout, getUserInfo,qrLoginPc } from '@/api/login'
import sys_dic_api from '@/api/sys_dic'
import { getToken, setToken, removeToken,setIsOlePwd } from '@/utils/auth'
import toTree from '@/utils/to_tree'

import { Message, Notification,MessageBox  } from 'element-ui'

const user = {
  state: {
    login_name:null,
    is_oldPw:false,
    user_id:null,
    name: null,
    level: null,
    state: null,
    state_name: null,
    county: null,
    county_name: null,
    town: null,
    town_name: null,
    village: null,
    village_name: null,
    status: null,
    roles: [],
    perms: [],
    mobile:null,
    my_district_tree: {},
    my_district_county:{},
    trial_version:0
  },

  mutations: {
    SET_LOGIN_NAME:(state, loginName) => {
      state.login_name = loginName
    },
    SET_USER_ID:(state, id) => {
      state.user_id = id
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_LEVEL: (state, level) => {
      state.level = level
    },
    SET_STATE: (state, state_id) => {
      state.state = state_id
    },
    SET_STATE_NAME: (state, state_name) => {
      state.state_name = state_name
    },
    SET_COUNTY: (state, county) => {
      state.county = county
    },
    SET_COUNTY_NAME: (state, county_name) => {
      state.county_name = county_name
    },
    SET_TOWN: (state, town) => {
      state.town = town
    },
    SET_TOWN_NAME: (state, town_name) => {
      state.town_name = town_name
    },
    SET_VILLAGE: (state, village) => {
      state.village = village
    },
    SET_VILLAGE_NAME: (state, village_name) => {
      state.village_name = village_name
    },
    SET_STATUS: (state, status) => {
      state.status = status
    },
    SET_ROLES: (state, roles) => {
      if (roles) {
        state.roles = roles.split(',')
      }
    },
    SET_PERM: (state, perms) => {
      if (perms) {
        state.perms = perms.split(',')
      }
    },
    SET_MY_DISTRICT_TREE: (state, data) => {
      state.my_district_tree = data
    },
    SET_MY_DISTRICT_County_TREE: (state, data) => {
      state.my_district_county = data
    },
    SET_IS_OLD_PW: (state, data) => {
       state.is_oldPw = data
    },
    SET_MOBILE: (state, data) => {
       state.mobile = data
    },
    SET_TrialVersion: (state, data) => {
      state.trial_version = data
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(username, userInfo.password,userInfo.validate_code).then(response => {
          if (response.data && response.data.success) {
            if (userInfo.password == "XjSHJZ.2306") {
              commit('SET_IS_OLD_PW', false)
              setIsOlePwd("0")
            } else {
              commit('SET_IS_OLD_PW', false)
              setIsOlePwd("0")
            }
			      resolve()
          } else { reject(response) }
        }).catch(error => {
          reject(error)
        })
      })
    },
    loginByQr ({ commit }, token) {
      // "loginByQr")
      // token)
      // "loginByQr")
      return new Promise((resolve, reject) => {
        qrLoginPc({token:token}).then(response => {
          if (response.data && response.data.success) {
              commit('SET_IS_OLD_PW', false)
              setIsOlePwd("0")
			      resolve()
          } else { reject(response) }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetUserInfo({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(response => {
          if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
            reject('获取用户信息失败')
          }
		      if (!response.data.success) {
            reject(response.data.data)
          }
          const data = response.data.data.list
          commit('SET_LOGIN_NAME', data.login_name)
          commit('SET_USER_ID', data.id)
          commit('SET_NAME', data.person_name)
          commit('SET_LEVEL', data.level)
          commit('SET_STATE', data.state)
          commit('SET_STATE_NAME', data.state_name)
          commit('SET_COUNTY', data.county)
          commit('SET_COUNTY_NAME', data.county_name)
          commit('SET_TOWN', data.town)
          commit('SET_TOWN_NAME', data.town_name)
          commit('SET_VILLAGE', data.village)
          commit('SET_VILLAGE_NAME', data.village_name)
          commit('SET_STATUS', data.status)
          commit('SET_ROLES', data.role_names)
          commit('SET_PERM', data.perms)
          commit('SET_MOBILE', data.mobile)
          commit('SET_TrialVersion', data.trial_version)


          // setMenu
          dispatch('setMenu', [])
          // this.setMyDistrictTree(commit, data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_NAME', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_NAME', '')
        commit('SET_ROLES', '')
        commit('SET_PERM', '')
        removeToken()
        resolve()
      })
    },
    setMyDistrictTree({ commit }, data) {
      // sys_dic_api()
      // const treeQuery = {
      //   type: '行政区划'
      // }
      // treeQuery.deep = 6 - data.level
      // if (data.level === 1) {
      //   treeQuery['pname'] = '新疆维吾尔自治区'
      // } else if (data.level === 2) {
      //   treeQuery['pname'] = data.state_name
      // } else if (data.level === 3) {
      //   treeQuery['pname'] = data.county_name
      // } else if (data.level === 4) {
      //   treeQuery['pname'] = data.town_name
      // }
      // sys_dic_api.list_tree(treeQuery).then(response => {
      //   const tmpData = response.data.data
      //   if (data.level === 2) {
      //     tmpData.push({ value: data.state, name: data.state_name, pname: '新疆维吾尔自治区' })
      //   } else if (data.level === 3) {
      //     tmpData.push({ value: data.state, name: data.state_name, pname: '新疆维吾尔自治区' })
      //     tmpData.push({ value: data.county, name: data.county_name, pname: data.state_name })
      //   } else if (data.level === 4) {
      //     tmpData.push({ value: data.state, name: data.state_name, pname: '新疆维吾尔自治区' })
      //     tmpData.push({ value: data.county, name: data.county_name, pname: data.state_name })
      //     tmpData.push({ value: data.town, name: data.town_name, pname: data.county_name })
      //   }
      //   const tree_data = toTree(tmpData, 'name', 'pname', '新疆维吾尔自治区')
      commit('SET_MY_DISTRICT_TREE', data)
      // })
    },
    setMyDistrictTreeCounty({ commit }, data) {
      // sys_dic_api()
      // const treeQuery = {
      //   type: '行政区划'
      // }
      // treeQuery.deep = 6 - data.level
      // if (data.level === 1) {
      //   treeQuery['pname'] = '新疆维吾尔自治区'
      // } else if (data.level === 2) {
      //   treeQuery['pname'] = data.state_name
      // } else if (data.level === 3) {
      //   treeQuery['pname'] = data.county_name
      // } else if (data.level === 4) {
      //   treeQuery['pname'] = data.town_name
      // }
      // sys_dic_api.list_tree(treeQuery).then(response => {
      //   const tmpData = response.data.data
      //   if (data.level === 2) {
      //     tmpData.push({ value: data.state, name: data.state_name, pname: '新疆维吾尔自治区' })
      //   } else if (data.level === 3) {
      //     tmpData.push({ value: data.state, name: data.state_name, pname: '新疆维吾尔自治区' })
      //     tmpData.push({ value: data.county, name: data.county_name, pname: data.state_name })
      //   } else if (data.level === 4) {
      //     tmpData.push({ value: data.state, name: data.state_name, pname: '新疆维吾尔自治区' })
      //     tmpData.push({ value: data.county, name: data.county_name, pname: data.state_name })
      //     tmpData.push({ value: data.town, name: data.town_name, pname: data.county_name })
      //   }
      //   const tree_data = toTree(tmpData, 'name', 'pname', '新疆维吾尔自治区')
      commit('SET_MY_DISTRICT_County_TREE', data)
      // })
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js